import Cookies from "./cookies";
import * as banner from "./banner";
import * as ZeplinApi from "./api";
import { urlResolve } from "./utils/url";
import { pluralize } from "./utils/string";
import { INTERCOM_APP_ID } from "./constants";
import { getDateDifference } from "./utils/date";
import { organizationPrefs } from "./prefs";

var plans;
function getPlans() {
    if (plans) {
        return Promise.resolve(plans);
    }

    return ZeplinApi.getPlans().then(resJson => {
        plans = Object.freeze(resJson);
        return plans;
    });
}

function getPlanById(planId) {
    return getPlans().then(plansResult => plansResult.find(plan => plan.id === planId));
}

window.addEventListener("storage", ev => {
    if (ev.storageArea === localStorage && ev.key === "user") {
        var oldUserObj = JSON.parse(ev.oldValue);
        var newUserObj = JSON.parse(ev.newValue);

        if (!newUserObj) {
            return;
        }

        Zeplin.user = newUserObj;

        if (oldUserObj._id !== newUserObj._id) {
            return location.reload();
        }
    }
});

/* eslint-disable */

// Intercom
(function(){var w=window;var ic=w.Intercom;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;
s.src='https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()

/* eslint-enable */

if (Cookies.get("userToken")) {
    Intercom("boot", {
        "app_id": INTERCOM_APP_ID,
        "user_id": Zeplin.user._id,
        "user_hash": Zeplin.user.intercomHash,
        "email": Zeplin.user.email,
        "last_seen_user_agent": navigator.userAgent,
        "last seen at web": Math.floor(Date.now() / 1000),
        "username": Zeplin.user.username,
        "verified": Zeplin.user.status === "verified",
        "plan": Zeplin.user.paymentPlan
    });
}

const billingTab = document.querySelector("#billingTab");
function switchToBillingTab(ev, type) {
    banner.closeBanner("payment");

    if (billingTab) {
        ev.preventDefault();

        const titleText = `Billing - ${type === "organization" ? "Organization " : ""}Profile - Zeplin`;

        history.replaceState({}, titleText, ev.target.href);
        document.querySelector("title").textContent = titleText;

        document.querySelector("header.tabs").dataset.selection = "billing";
        billingTab.checked = true;
    }
}

/**
 * Shows failed payment banner
 *
 * @param {Object} data
 * @param {String} data.oid Organization id
 * @param {String} data.currentRole Role of the current user
 * @param {String} data.ownerEmail Email of the project owner
 * @param {Boolean} data.isGeneric Whether the failed payment is generic to all projects
 */
function showFailedPaymentBanner(data) {
    let content;
    let bodyCallbacks;

    if (data.oid) {
        if (data.currentRole === "queen" || data.currentRole === "king") {
            content = `Payment failed: Make sure to <a href="${urlResolve("workspace-profile-billing", { url: { oid: data.oid } })}">update your payment information</a> to keep ${data.isGeneric ? "projects" : "this project"} active.`;
            bodyCallbacks = {
                a(ev) {
                    switchToBillingTab(ev, "organization");
                }
            };
        }
    } else if (data.currentRole === "owner") {
        content = `Payment failed: Make sure to <a href="${urlResolve("profile-billing")}">update your payment information</a> to keep ${data.isGeneric ? "your projects" : "this project"} active.`;
        bodyCallbacks = {
            a(ev) {
                switchToBillingTab(ev, "user");
            }
        };
    } else {
        content = `Payment failed: Please contact the owner (<a href="mailto:${data.ownerEmail}" target="_blank">${data.ownerEmail}</a>) of this project and ask them to update their payment information, to keep this project active.`;
    }

    if (content) {
        banner.show({
            contentType: "html",
            group: "payment",
            content,
            bodyCallbacks
        });
    }
}

function hideFailedPaymentBanner() {
    banner.closeBanner("payment");
}

/**
 * Shows cancelled subscription banner
 * Banner is shown if the time until cancellation is below maxHoursBeforeAlert
 *
 * Remaining days value is shown in the banner in the following manner:
 * Let x and y denote the time difference between now and the subscription cancel date like x days and y hours
 * If x is 0, show "in less than a day" in the banner
 * Else if y is larger than the MIN_HOURS_FOR_ROUND_UP value, show "in x + 1 days"
 * Otherwise, show "in x day(s)".
 *
 * @param {Object} data
 * @param {String} data.oid Organization id
 * @param {String} data.currentRole Role of the current user
 * @param {Number} data.subscriptionCancelAt Date at which the subscription will be cancelled
 */
function showCancelledSubscriptionBannerIfNecessary(data) {
    const HOURS_IN_DAYS = 24;
    const MAX_HOURS_BEFORE_ALERT = 168; // 1 week
    const MIN_HOURS_FOR_ROUND_UP = 3;
    const { oid, currentRole, subscriptionCancelAt } = data;
    const differenceInHours = getDateDifference("h", new Date(), subscriptionCancelAt);
    if (differenceInHours > MAX_HOURS_BEFORE_ALERT) {
        return;
    }

    let bodyCallbacks;
    let dayCount = Math.floor(differenceInHours / HOURS_IN_DAYS);
    const remainderHours = differenceInHours % HOURS_IN_DAYS;
    if (dayCount > 0 && remainderHours >= MIN_HOURS_FOR_ROUND_UP) {
        dayCount++;
    }

    const dayCountText = dayCount < 1 ? "less than a day" : `${pluralize(dayCount, "day")}`;
    let content = `Since your subscription has been canceled, your projects will be archived automatically in ${dayCountText} —`;

    if (oid && (currentRole === "queen" || currentRole === "king")) {
        content += ` <a href="${urlResolve("workspace-profile-billing", { url: { oid: data.oid } })}">resubscribe</a>`;
        bodyCallbacks = {
            a(ev) {
                switchToBillingTab(ev, "organization");
            }
        };
    } else if (currentRole === "owner") {
        content += ` <a href="${urlResolve("profile-billing")}">resubscribe</a>`;
        bodyCallbacks = {
            a(ev) {
                switchToBillingTab(ev, "user");
            }
        };
    }

    content += " to keep them active.";

    banner.show({
        contentType: "html",
        group: "cancelledSubscription",
        content,
        bodyCallbacks
    });
}

function hideCancelledSubscriptionBanner() {
    banner.closeBanner("cancelledSubscription");
}

function updateEmotar(emotar) {
    return ZeplinApi.updateUserEmotar(emotar);
}

/**
 * Shows organization frozen banner
 *
 * @param {Object} data
 * @param {String} data.oid Organization id
 * @param {String} data.currentRole Role of the current user
 */
function showOrganizationFrozenBanner(data) {
    let bodyCallbacks;
    let content;

    if (["king", "queen"].includes(data.currentRole)) {
        content = `Due to a failed payment, your workspace has been suspended — <a href="${urlResolve("workspace-profile-billing", { url: { oid: data.oid } })}">update your payment information</a> to re-activate it.`;
        bodyCallbacks = {
            a(ev) {
                switchToBillingTab(ev, "organization");
            }
        };
    } else {
        content = "Due to a failed payment, your workspace has been suspended. Contact an Admin to update the payment information and activate the workspace.";
    }

    banner.show({
        content,
        contentType: "html",
        group: "organizationFrozen",
        bodyCallbacks
    });
}

function hideOrganizationFrozenBanner() {
    banner.closeBanner("organizationFrozen");
}

function hideSubscriptionStatusBanners() {
    const targetGroups = ["organizationFrozen", "cancelledSubscription", "payment"];

    targetGroups.forEach(banner.closeBanner);
}

async function showAddressBannerIfNecessary({
    organizationId,
    organizationStatus,
    subscriptionStatus,
    orgRole,
    userPaymentPlan
}) {
    const missingAddressBannerLastSeenDate = await organizationPrefs.get(organizationId, "missingAddressBannerLastSeenDate");
    const todayDate = new Date();

    if (missingAddressBannerLastSeenDate && getDateDifference("d", missingAddressBannerLastSeenDate, todayDate) < 1) {
        return;
    }
    let bannerContent;
    let billingInfo;
    if (organizationId === "user" && !["free", "bff", "non_profit"].includes(userPaymentPlan?.toLowerCase())) {
        billingInfo = await ZeplinApi.getUserBilling();
        bannerContent = `Action required: Please enter your billing address to keep your projects active — <a href="${urlResolve("profile-billing", { query: { showAddressDialog: true } })}">enter billing address.</a>`;
    } else if (subscriptionStatus !== "trialing" && ["active", "frozen"].includes(organizationStatus) && orgRole && ["king", "queen"].includes(orgRole)) {
        billingInfo = await ZeplinApi.getOrganizationBilling(organizationId);
        bannerContent = `Action required: Please enter your billing address to keep your projects active — <a href="${urlResolve("workspace-profile-billing", { url: { oid: organizationId }, query: { showAddressDialog: true } })}">enter billing address.</a>`;
    }
    if (!billingInfo?.billing.address && bannerContent) {
        banner.show({ content: bannerContent,
            group: "billingAddressInfo",
            contentType: "html",
            closeCallback() {
                organizationPrefs.set(organizationId, "missingAddressBannerLastSeenDate", todayDate);
            } });
    }
}

export {
    getPlans,
    getPlanById,
    showFailedPaymentBanner,
    hideFailedPaymentBanner,
    showCancelledSubscriptionBannerIfNecessary,
    hideCancelledSubscriptionBanner,
    showOrganizationFrozenBanner,
    hideOrganizationFrozenBanner,
    updateEmotar,
    hideSubscriptionStatusBanners,
    showAddressBannerIfNecessary
};
